const HOST = `https://arbitr-parser-api.fullstack-freelancer.ru`;
export default HOST;
